import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api/expenses`;
export const listExpenses = params => axios.get(API, { params });
export const getExpense = id => axios.get(`${API}/${id}`);
export const createExpense = data => axios.post(API, data);
export const updateExpense = (id, data) => axios.put(`${API}/${id}`, data);
export const deleteExpense = id => axios.delete(`${API}/${id}`);
export const submitExpense = id => axios.post(`${API}/${id}/submit`);
export const reviewExpense = (id, data) => axios.post(`${API}/${id}/review`, data);
export const getExpenseOwners = () => axios.get(`${API}/owners`);
export const getExpenseReference = () => axios.get(`${API}/reference`);
export const exportExpenses = params => axios.get(`${API}/export`, { params, responseType: "blob" });
export const getExpenseVehicles = owner_id => axios.get(`${API}/vehicles`, { params: { owner_id } });
export const createExpenseVehicle = data => axios.post(`${API}/vehicles`, data);
export const updateOpeningMileage = (id, data) => axios.put(`${API}/vehicles/${id}/opening`, data);
export const searchExpensePlaces = query => axios.post(`${API}/places`, { query });
export const calculateExpenseRoute = data => axios.post(`${API}/routes`, data);
export const uploadExpenseReceipt = (id, file, onUploadProgress) => {
  const body = new FormData(); body.append("file", file);
  return axios.post(`${API}/${id}/receipts`, body, { onUploadProgress });
};
export const fetchExpenseReceipt = (id, fileId, signal) => axios.get(`${API}/${id}/receipts/${fileId}/content`, { responseType: "blob", signal });
export const deleteExpenseReceipt = (id, fileId) => axios.delete(`${API}/${id}/receipts/${fileId}`);